import { Avatar, Box, Button, Stack, Typography } from "@mui/material";
// import ImageUpload from '../../step-three/ImageUpload'

import CancelIcon from "@mui/icons-material/Cancel";
import ClearIcon from "@mui/icons-material/Clear";
import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useFormContext } from "react-hook-form";
import { useAppDispatch } from "store/appHooks";
import ImageUploadBox from "../ImageUploadBox";
import { Label, SubTitle, Title } from "../mui.styles";
const centerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const ListingImages = (props: any) => {
  const {
    currentStep,
    generalReducer,
    setCurrentStep,
    changeStepStatus,
    stepStatus,
  } = props;
  const {
    setValue,
    control,
    watch,
    trigger,
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const values = watch();

  const dispatch = useAppDispatch();
  const equipmentType = values?.equipmentType;
  const dropZoneProps = useDropzone({ accept: { "image/*": [] } });
  const { acceptedFiles } = dropZoneProps;
  const [error, setError]: any = useState({ show: false, message: "" });

  const { images } = values;

  useEffect(() => {
    if (stepStatus[currentStep]?.error) {
      navigateNext();
    }
  }, [stepStatus[currentStep]?.error]);

  const navigateNext = async () => {
    const res = await trigger("images");
    if (res) {
      setError({ show: false, message: "" });
      setCurrentStep("Usage Rates");
      changeStepStatus(currentStep, "submitted", true);
    } else {
      setError({
        show: true,
        message: errors?.images?.message || "Invalid Input",
      });
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // setCurrentStep("Pricing and Usage Rates");
    // onWizardStateChange(
    //   [currentStep, "stepStatus", "submitted"],
    //   true,
    //   setWizardState
    // );
  };

  useEffect(() => {
    acceptedFiles?.length && setValue("images", [...images, ...acceptedFiles]);
  }, [acceptedFiles, setValue]);

  const imgDeleteHandler = (ind: number, isCloudImg: boolean, img: any) => {
    if (isCloudImg) {
      setValue("deletedImages", [...(values?.deletedImages || []), img]);
    }
    setValue(
      "images",
      images?.filter((el: any, index: number) => index != ind)
    );
  };

  return (
    <Box sx={{ p: "10px", width: "100%" }}>
      <Title>Upload Images</Title>
      <SubTitle>
        we require few images for your Equipment (Add Minimum 2 Images & Maximum
        6 Images)
      </SubTitle>
      <br />
      <Label>Images</Label>

      <br />

      {error?.show && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 4,
          }}
        >
          <Typography textAlign={"center"} color="error" variant="body1">
            {error?.message || " "}
          </Typography>
        </Box>
      )}

      <Box sx={{ width: "100%" }}>
        <Stack
          spacing={{ xs: 1.5, sm: 2 }}
          direction="row"
          useFlexGap
          flexWrap="wrap"
        >
          <ImageUploadBox dropZoneProps={dropZoneProps} />
          {images?.map((img: any, ind: number) => (
            <Box sx={{ position: "relative" }}>
              <ClearIcon
                onClick={() => imgDeleteHandler(ind, "preview_url" in img, img)}
                sx={{
                  position: "absolute",
                  top: -12,
                  right: -12,
                  zIndex: 99,
                  cursor: "pointer",
                  color: "#fff",
                  backgroundColor: "#D21A00",
                  borderRadius: "100%",
                  fontSize: "16px",
                  p: 0.55,
                }}
              />
              <Avatar
                key={ind}
                sx={{
                  // maxWidth: "192px",
                  width: "192px",
                  height: "192px",
                  borderRadius: "8px",
                }}
                variant="rounded"
                src={
                  "preview_url" in img
                    ? img?.preview_url
                    : URL.createObjectURL(img)
                }
              ></Avatar>
            </Box>
          ))}
        </Stack>
        <Box
          mt={2.5}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          mr={2}
          gap="10px"
        >
          <Button
            sx={{
              backgroundColor: "transparent",
              color: "primary.main",
              border: "1px solid #dfdfdf",
            }}
            variant="contained"
            type="submit"
            // disabled={listingReducer?.submittingListingData}
            // endIcon={
            //   listingReducer.submittingListingData ? (
            //     <CircularProgress size={15} />
            //   ) : null
            // }
            onClick={() =>
              setCurrentStep(
                equipmentType == 1 ? "Configurations" : "Basic Details"
              )
            }
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={navigateNext}

            // disabled={listingReducer?.submittingListingData}
            // endIcon={
            //   listingReducer.submittingListingData ? (
            //     <CircularProgress size={15} />
            //   ) : null
            // }
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ListingImages;
